module.exports = __webpack_public_path__ + "static/img/181221-cngb3-drawing.e692942.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/181221-cngb3-drawing.jpg
// module id = oQ7j
// module chunks = 0